import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import Dialog from "material-ui/Dialog";
import RaisedButton from "material-ui/RaisedButton";
import { getToken } from "../../store/login";
import { message } from "../../store/messageBar";
import { registerFormVisible, register } from "../../store/register";
import { updateCartItemsQty } from "../../store/cartItems";
import { updateWalletItemsQty } from "../../store/walletItems";
import TextField from "material-ui/TextField";
import Checkbox from "material-ui/Checkbox";
import { loginFormVisible } from "../../store/login";
import { Popover } from 'material-ui';

class RegisterForm extends React.Component {
  handleClose = () => {
    this.registerForm(false);
  };

  handleSignIn = () => {
    this.props.loginWindow(true);
    this.handleClose();
  };

  handleSignUp = () => {
    const { agree, understandDining, understandRedeem } = this.state.form;
    if (!agree || !understandDining || !understandRedeem) {
      this.setState({ bannerOpen: true, anchorEl: this.checkBoxEl.current });
    }

    let valid = true,
      error = {};
    if (this.state.form.password !== this.state.form.password2) {
      error.password2 = "The confirm password should be the same";
      valid = false;
    }
    if (this.state.form.email === "") {
      error.email = "The field can not be empty";
      valid = false;
    }
    if (this.state.form.email.toLowerCase().trim() !== this.state.form.confirm_email.toLowerCase().trim()) {
      error.confirm_email = "The email fields should be the same";
      valid = false;
    }
    if (this.state.form.zipcode === "") {
      error.zipcode = "The field can not be empty";
      valid = false;
    }
    if (!this.state.form.agree) {
      error.agree = "#F00";
      valid = false;
    }
    if (!this.state.form.understandRedeem) {
      error.understandRedeem = "#F00";
      valid = false;
    }
    if (!this.state.form.understandDining) {
      error.understandDining = "#F00";
      valid = false;
    }
    if (valid) {
      this.register(
        this.state.form.email,        
        this.state.form.password,
        this.state.form.zipcode
      )
        .then(() => {
          this.login(this.state.form.email, this.state.form.password).then(
            () => {
              this.props.updateCartItemsQty();
              this.props.updateWalletItemsQty();
            }
          );
          this.handleClose();
        })
        .catch(error => {
          this.message(error.response.data.error);
        });
    } else {
      this.setState({ error: error });
    }
  };

  handleInput = e => {
    let form = this.state.form;
    form[e.target.id] = e.target.value;
    let error = this.state.error;
    if (e.target.id === "password2") {
      if (this.state.form.password === this.state.form.password2) {
        error.password2 = "";
      }
    } else {
      if (this.state.form[e.target.id] !== "") {
        error[e.target.id] = "";
      }
    }
    this.setState({ form: form, error: error });
  };

  updateCheck = key => {
    let form = { ...this.state.form };
    let error = { ...this.state.error };
    form[key] = !this.state.form[key];
    if (form[key]) {
      error[key] = "#000";
    }
    this.setState({ form: form, error: error });
  };

  constructor(props) {
    super(props);

    this.state = {
      showWindow: this.props.showWindow,
      form: {
        confirm_email: "",
        email: "",
        password: "",
        zipcode: "",
        agree: false,
        understandRedeem: false,
        understandDining: false
      },
      error: {
        password2: "",
        email: "",
        confirm_email: "",
        zipcode: "",
        agree: "#000",
        understandRedeem: "#000",
        understandDining: "#000"
      },
      bannerOpen: false,
      anchorEl: null
    };
    this.checkBoxEl = React.createRef();
    this.registerForm = this.props.registerWindow;
    this.login = this.props.login;
    this.register = this.props.register;
    this.message = this.props.showMessage;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showWindow !== this.state.showWindow) {
      this.setState({ showWindow: nextProps.showWindow });
    }
  }

  handleBannerClose = () => this.setState({ bannerOpen: false });

  render() {
    const actions = [
      <RaisedButton
        label="SIGN UP"
        onClick={this.handleSignUp}
        backgroundColor="#323993"
        labelColor="#ffffff"
        className="mr-2"
      />
    ];

    const termsLabel = (
      <span>
        I agree to the terms and conditions of the website. You can view the
        Terms of Service by clicking &nbsp;
        <Link
          className={"singup-terms-link"}
          to="/terms-conditions"
          target="_blank"
          style={{ zIndex: 99999, position: "relative" }}
        >
          TERMS AND CONDITIONS
        </Link>
      </span>
    );

    const appLabel = (
      <span className="app-label">
        I understand that to redeem all deals purchased through the 
        Deal Marketplace™
        <br />{" "}
        <span>
          I must download and redeem the deal through the&nbsp;
          <span>FREE</span>&nbsp; Xooker App. This is for your security and
          privacy.
        </span>
      </span>
    );

    const dineInLabel = (
      <span className="dine-in-label">
        I understand that all FOOD AND DINING Deals must be&nbsp;
        <i className="underline">Dine-In</i> or{" "}
        <i className="underline">Carry Out ONLY.</i>&nbsp;
        <b className="bold text-danger">
          <i>
            YOU CANNOT use 
            Deal Marketplace™ deals for DELIVERY, unless otherwise noted by
            restaurant.
          </i>
        </b>
      </span>
    );

    return (
      <div>
        <Dialog
          actions={actions}
          modal={true}
          open={this.state.showWindow}
          contentClassName={"login-dialog_content sing-page"}
          actionsContainerClassName="actions"
          autoScrollBodyContent={true}
        >
          <div className="dialog-body-wrapper">
            <div className="sing-logo-container"> 
              <p>
                <span>Deal Marketplace™</span>
                <b>Sign Up</b>
              </p>
              <i className="material-icons" onClick={this.handleClose}>
                close
              </i>
            </div>
            <p className="marketplace-banner">            
            </p>
         
            <TextField
              hintText="Email Field"
              floatingLabelText="Email"
              type="text"
              id="email"
              onChange={this.handleInput}
              value={this.state.form.email}
              errorText={this.state.error.email}
              underlineFocusStyle={{ borderColor: "#333c8f" }}
              floatingLabelStyle={{ color: "#333c8f" }}
              style={{ width: "420px" }}
              className="input-field"
            />
            <br />
            <TextField
              hintText="Confirm Email"
              floatingLabelText="Confirm Email"
              type="text"
              id="confirm_email"
              onChange={this.handleInput}
              value={this.state.form.confirm_email}
              errorText={this.state.error.confirm_email}
              underlineFocusStyle={{ borderColor: "#333c8f" }}
              floatingLabelStyle={{ color: "#333c8f" }}
              style={{ width: "420px" }}
              className="input-field"
            />
            <br />            
            <TextField
              hintText="Zip code Field"
              floatingLabelText="Zip code"
              type="text"
              id="zipcode"
              onChange={this.handleInput}
              value={this.state.form.zipcode}
              errorText={this.state.error.zipcode}
              underlineFocusStyle={{ borderColor: "#333c8f" }}
              floatingLabelStyle={{ color: "#333c8f" }}
              style={{ width: "420px" }}
              className="input-field"
            />
            <br />
            <TextField
              hintText="Password Field"
              floatingLabelText="Password"
              type="password"
              id="password"
              onChange={this.handleInput}
              value={this.state.form.password}
              underlineFocusStyle={{ borderColor: "#333c8f" }}
              floatingLabelStyle={{ color: "#333c8f" }}
              style={{ width: "420px" }}
              className="input-field"
            />
            <br />
            <TextField
              hintText="Confirm Password Field"
              floatingLabelText="Confirm Password"
              type="password"
              id="password2"
              onChange={this.handleInput}
              value={this.state.form.password2}
              errorText={this.state.error.password2}
              underlineFocusStyle={{ borderColor: "#333c8f" }}
              floatingLabelStyle={{ color: "#333c8f" }}
              style={{ width: "420px", marginBottom: "15px" }}
              className="input-field"
            />
            <br />
            <Checkbox
              label={termsLabel}
              checked={this.state.form.agree}
              onCheck={() => this.updateCheck("agree")}
              labelStyle={{ color: this.state.error.agree }}
              className="checkbox-field"
            />
            <div ref={this.checkBoxEl} />
            <Checkbox
              label={appLabel}
              checked={this.state.form.understandRedeem}
              onCheck={() => this.updateCheck("understandRedeem")}
              labelStyle={{ color: this.state.error.understandRedeem }}
              className="checkbox-field"
            />
            <Checkbox
              label={dineInLabel}
              checked={this.state.form.understandDining}
              onCheck={() => this.updateCheck("understandDining")}
              labelStyle={{ color: this.state.error.understandDining }}
              className="checkbox-field"
            />
            <Popover
              open={this.state.bannerOpen}
              anchorEl={this.state.anchorEl}
              anchorOrigin={{horizontal: 'middle', vertical: 'top'}}
              targetOrigin={{horizontal: 'middle', vertical: 'top'}}
              onRequestClose={this.handleBannerClose}
              className="i-acknowledge-banner-container sign-up"
            >
              <div className="i-acknowledge-banner" onClick={this.handleBannerClose}>
                Please indicate that you have read and agree to all the terms and conditions by checking the box(es).
                <span>x</span>
              </div>
            </Popover>
          </div>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    showWindow: state.register
  };
};

const mapDispatchToProps = dispatch => {
  return {
    registerWindow: value => dispatch(registerFormVisible(value)),
    login: (email, password) => dispatch(getToken(email, password)),
    register: (email, zipcode, password) =>
      dispatch(register(email, zipcode, password)),
    showMessage: text => dispatch(message(text)),
    loginWindow: value => dispatch(loginFormVisible(value)),
    updateWalletItemsQty: () => dispatch(updateWalletItemsQty()),
    updateCartItemsQty: () => dispatch(updateCartItemsQty())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterForm);



// WEBPACK FOOTER //
// ./src/components/ModalWindow/RegisterForm.js